import {
  OptionRecord,
  PartialScreenWithCoveragesRecord,
  ScreenWithCoverages,
} from "../../../types";

enum MineSubsidenceOption {
  Default = "Default",
  Illinois = "Illinois",
  Indiana = "Indiana",
  IndianaOwner = "Indiana Owner",
}

const mineSubsidenceName: OptionRecord<MineSubsidenceOption, string> = {
  [MineSubsidenceOption.Default]: "Mine Subsidence - Unscheduled",
  [MineSubsidenceOption.Illinois]:
    "Mine Subsidence - Dwelling and Unscheduled Other Structures",
};

const mineSubsidenceDescription: OptionRecord<
  MineSubsidenceOption,
  PartialScreenWithCoveragesRecord
> = {
  [MineSubsidenceOption.Default]: {
    [ScreenWithCoverages.PlanDetails]:
      "Provides coverage for the collapse of an underground mine that causes damage to your structure.",
    [ScreenWithCoverages.ExtraCoverages]:
      "Provides coverage for the collapse of an underground mine that causes damage to your structure.",
  },
  [MineSubsidenceOption.Indiana]: {
    [ScreenWithCoverages.PlanDetails]:
      "Provides coverage for the collapse of an underground coal mine that causes damage to your structure.",
    [ScreenWithCoverages.ExtraCoverages]:
      "Provides coverage for the collapse of an underground coal mine that causes damage to your structure.",
  },
  [MineSubsidenceOption.IndianaOwner]: {
    [ScreenWithCoverages.PlanDetails]:
      "Provides coverage for the collapse of an underground coal mine that causes damage to your structure.",
    [ScreenWithCoverages.ExtraCoverages]:
      "Provides coverage for the collapse of an underground coal mine that causes damage to your structure.",
  },
};

const mineSubsidenceTooltip: OptionRecord<
  MineSubsidenceOption,
  PartialScreenWithCoveragesRecord
> = {
  [MineSubsidenceOption.Default]: {
    [ScreenWithCoverages.PlanDetails]:
      "Coverage is provided for your primary dwelling and other structures.",
    [ScreenWithCoverages.ExtraCoverages]:
      "Coverage is provided for your primary dwelling and other structures.",
    [ScreenWithCoverages.PolicySummary]:
      "Provides coverage for the collapse of an underground mine that causes damage to your structure. Coverage is provided for your primary dwelling and other structures.",
  },
  [MineSubsidenceOption.Indiana]: {
    [ScreenWithCoverages.PlanDetails]:
      "Coverage is provided for your primary dwelling, other structures.",
    [ScreenWithCoverages.ExtraCoverages]:
      "Coverage is provided for your primary dwelling, other structures.",
    [ScreenWithCoverages.PolicySummary]:
      "Provides coverage for the collapse of an underground coal mine that causes damage to your structure. Coverage is provided for your primary dwelling, other structures.",
  },
  [MineSubsidenceOption.IndianaOwner]: {
    [ScreenWithCoverages.PlanDetails]:
      "Coverage is provided for your primary dwelling, other structures, and Additional Living Expense when purchased",
    [ScreenWithCoverages.ExtraCoverages]:
      "Coverage is provided for your primary dwelling, other structures, and Additional Living Expense when purchased",
    [ScreenWithCoverages.PolicySummary]:
      "Provides coverage for the collapse of an underground coal mine that causes damage to your structure. Coverage is provided for your primary dwelling, other structures, and Additional Living Expense when purchased.",
  },
};

const getMineSubsidenceName = (
  mineSubsidenceOption: MineSubsidenceOption
): string =>
  mineSubsidenceName[mineSubsidenceOption]
    ? mineSubsidenceName[mineSubsidenceOption]
    : mineSubsidenceName[MineSubsidenceOption.Default];

const getMineSubsidenceDescription = (
  mineSubsidenceOption: MineSubsidenceOption,
  screen: ScreenWithCoverages
): string | undefined =>
  mineSubsidenceDescription[mineSubsidenceOption]
    ? mineSubsidenceDescription[mineSubsidenceOption][screen]
    : mineSubsidenceDescription[MineSubsidenceOption.Default][screen];

const getMineSubsidenceTooltip = (
  mineSubsidenceOption: MineSubsidenceOption,
  screen: ScreenWithCoverages
): string | undefined =>
  mineSubsidenceTooltip[mineSubsidenceOption]
    ? mineSubsidenceTooltip[mineSubsidenceOption][screen]
    : mineSubsidenceTooltip[MineSubsidenceOption.Default][screen];

export {
  MineSubsidenceOption,
  getMineSubsidenceName,
  getMineSubsidenceDescription,
  getMineSubsidenceTooltip,
};
